export default "__VITE_ASSET__48b50948__"